export default __webpack_public_path__ + "static/media/Ballroll_00140.61cd0683.png";